import React from 'react';
import HomeView from './HomeView';

const WorkoutView = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#fbeff3', fontFamily: 'Inter, Roboto, Segoe UI, Arial, sans-serif', color: '#333' }}>
      <HomeView />
    </div>
  );
};

export default WorkoutView;
